var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-item',{staticClass:"error-item k-bg-danger k-pa-x-md k-text-size-content",attrs:{"title":_vm.message,"right-icon":_vm.rightIconName,"title-color":"white","title-size":"content"},on:{"click":_vm.onAction}})}
var staticRenderFns = []

export { render, staticRenderFns }